// extracted by mini-css-extract-plugin
module.exports = {"collection_container":"style_collection_container__2KIxh"};